import { useState } from 'react';
import { useSelector } from 'react-redux';
import { selectCurrentEvent } from './event.slice';

const initialState = {
  event: {},
  contact: {},
  location: {},
  preferences: {},
  event_subtype: {},
};

const useEvent = () => {
  const event = useSelector(selectCurrentEvent);
  const [isPreRegister] = useState(event?.preferences?.pre_register === true);

  return {
    event: event || initialState,
    isPreRegister,
  };
};

export default useEvent;
